export default "__VITE_ASSET__54d559cd__"